import { ALPHANUMERIC_REGEX } from 'constants/regex'

export const notAlphanumeric = vin => !ALPHANUMERIC_REGEX.test(vin)
